import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { sendAlert } from '../../actions/utils';
import { ComponentDataTable, DefaultModal } from '../../components';
import { delayMethod } from '../../services/utils';
import { debounceIndexCompanyTaskRequest, deleteCompanyTaskRequest } from '../../requests/companyTasks';
import columns from './columns';

const CompanyTaskDatatable = ({ customParams, moreDataOverride, onEditAction, onShowAction, customColumns }) => {
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState({});
  const [modalItem, setModalItem] = useState(null);
  const [moreData, setMoreData] = useState(false);
  const [modalTitle, setModalTitle] = useState('Eliminar Tarea');
  const [withConfirm, setWithConfirm] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [amount, setAmount] = useState(0);
  const [onRequest, setOnRequest] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleIndexRequest = params => {
    setOnRequest(true);
    const finalParams = { ...customParams, ...params };

    const request = async () =>
      debounceIndexCompanyTaskRequest({
        dispatch,
        params: finalParams,
        successCallback: res => {
          const responseAmount = res?.data?.metadata?.amount || 0;
          setAmount(responseAmount);
          setTasks(res?.data?.data || []);
        },
        callback: () => setOnRequest(false)
      });
    request();
  };

  const handleDeleteRequest = id => {
    setOnRequest(true);
    deleteCompanyTaskRequest(id, {
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Tarea eliminada con éxito' }));
        setMoreData(!moreData);
      },
      callback: () => delayMethod(() => setModalShow(false))
    });
  };

  const handleActions = (item, action) => {
    switch (action) {
      case 'edit':
        setWithConfirm(true);
        if (onEditAction) {
          onEditAction(item);
        } else {
          history.push(`/tasks/${item.id}/edit`);
        }
        break;
      case 'destroy':
        setModalTitle('Eliminar tarea');
        setWithConfirm(true);
        setModalItem(item);
        setModalShow(true);
        setModalBody(`¿Estás seguro que deseas eliminar ${item.title}?`);
        break;
      case 'show':
        if (onShowAction) {
          onShowAction(item);
        } else {
          history.push(`/tasks/${item.id}`);
        }
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
        break;
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'status':
        return { sort_status: name };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <div className="data-table-yellow">
        <ComponentDataTable
          onRequest={onRequest}
          columns={customColumns ? customColumns(handleActions) : columns(handleActions)}
          data={tasks}
          moreData={moreData || moreDataOverride}
          handleSortCase={sortColumnCase}
          totalRows={amount}
          resourceRequest={handleIndexRequest}
          onRowClicked={row => handleActions(row, 'show')}
          withDateSelect={false}
          withSearch={false}
          rangePicker
          pointerOnHover
        />
      </div>
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={() => delayMethod(() => setModalShow(false))}
        titleBtnClose="Cerrar"
        handleConfirm={() => handleDeleteRequest(modalItem.id)}
        withConfirm={withConfirm}
        disabled={onRequest}
      />
    </>
  );
};

export default CompanyTaskDatatable;
